import React from 'react';
import ThemeSwitchContext from './ThemeSwitchContext';

import { createTheme, ThemeProvider as MuiThemeProvider } from '@material-ui/core';

const theme = createTheme({
  palette: {
    primary: {
      main: "#3277CE"
    },
    secondary: {
      main: "#FFFFFF",
    },
    background: {
      default: "#EAEAEA"
    }
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Noto Sans JP',
      'sans-serif',
    ].join(','),
  },
});

const themeHome = createTheme({
  palette: {
    primary: {
      main: "#1F91C9"
    },
    background: {
      default: "#1F91C9"
    },
    text: {
      primary: '#FFFFFF',
    },
  },
  typography: {
    fontFamily: [
      'Roboto',
      'Noto Sans JP',
      'sans-serif',
    ].join(','),

    button: {
      fontWeight: 700,
    },    
  },
});

export default function ThemeProvider(props)
{
  const [state, setState] = React.useState(false);
  
  return (
    <ThemeSwitchContext.Provider value={setState}>
      <MuiThemeProvider theme={state ? themeHome : theme}>
        {props.children}
      </MuiThemeProvider>
    </ThemeSwitchContext.Provider>
  );
}